import { render, staticRenderFns } from "./tab-three.vue?vue&type=template&id=3e5f4a93&"
import script from "./tab-three.vue?vue&type=script&lang=ts&"
export * from "./tab-three.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports